import { createAsyncThunk } from '@reduxjs/toolkit';
import authApi from 'api/authApi';
import employeeApi from 'api/employeeApi';

import userApi from 'api/usersApi';
import touchApi, { TouchesPayload } from 'api/touchApi';
import { updateUser, fillCompany, updateUserWorkActivity, addNewTouch, updateTouch } from './reducer';

const authorize = createAsyncThunk(
  'main/authorizeUser',
  async (arg, { dispatch }) => {
    try {
      const user = await authApi.check() as any;
      if (user.isSubclient) {
        const companies = await employeeApi.getListOfEmployeeCompanies(user.id);
        dispatch(fillCompany(companies));
      };

      dispatch(updateUser(user));
    } catch (err) {
      dispatch(updateUser(null));
    }
  },
);

export const addWorkActivity = createAsyncThunk(
  'main/workActivity',
  async (arg: {
    description?: string;
    teamId?: number | null;
    vacancies?: number[];
  }, {dispatch}) => {
    try {
      const activity = await userApi.workActivity(arg);

      dispatch(updateUserWorkActivity(activity));
    } catch (err) {
      dispatch(updateUserWorkActivity(null));
    }
  },
);

export const stopWorkActivity = createAsyncThunk(
  'main/stopWorkActivity',
  async (_, {dispatch}) => {
    try {
      await userApi.stopWorkActivity();

      dispatch(updateUserWorkActivity(null));
    } catch (err) {
      dispatch(updateUserWorkActivity(null));
    }
  },
);

export const setNewTouches = createAsyncThunk(
  'main/setNewTouches',
  async (data: TouchesPayload, {dispatch}) => {
    try {
      const newTouch = await touchApi.create(data);

      dispatch(addNewTouch(newTouch));
    } catch (err) {
      console.error(err);
    }
  },
);

export const updateTouches = createAsyncThunk(
  'main/updateTouches',
  async (data: {
      touchId: number,
      payload: Partial<TouchesPayload>,
    }, {dispatch}) => {
    try {
      const result = await touchApi.update(data.touchId, data.payload);

      dispatch(updateTouch(result));
    } catch (err) {
      console.error(err);
    }
  },
);

export default authorize;
